import pageReducer from './pageReducer';
import prerenderUserReducer from './prerenderUserReducer';
import cachedPagesReducer from './cachedPagesReducer';
import cachingActivityReducer from './cachingActivityReducer';
import cachingStatsReducer from './cachingStatsReducer';
import emailVerificationReducer from './emailVerificationReducer';
import billingInfoReducer from './billingInfoReducer';
import onboardingReducer from '../features/onboarding/redux/onboardingReducer';
import ignoredUrlsReducer from './ignoredUrlsReducer';
import usageStatisticsReducer from '../features/usage-statistics/redux/usageStatisticsReducer';
import keycloakReducer from './keycloakReducer';
import settingsReducer from '../features/settings/redux/settingsReducer';
import domainReducer from './domainReducer';
import { WalkthroughReducer } from '~features/FreeTrial/store';
import { CrawlerUpdateAnnouncementReducer } from '~features/ai-insights/store';

// combineReducers, gets called in store.js by configureStore
export default {
  page: pageReducer,
  prerenderUser: prerenderUserReducer,
  cachedPages: cachedPagesReducer,
  cachingActivity: cachingActivityReducer,
  cachingStats: cachingStatsReducer,
  ignoredUrls: ignoredUrlsReducer,
  emailVerification: emailVerificationReducer,
  billingInfo: billingInfoReducer,
  onboarding: onboardingReducer,
  usageStatistics: usageStatisticsReducer,
  keycloak: keycloakReducer,
  settings: settingsReducer,
  domains: domainReducer,
  freeTrialWalkthrough: WalkthroughReducer,
  aiInsightsCrawlerUpdateAnnouncement: CrawlerUpdateAnnouncementReducer,
};
